import useRequest from '../../utils/useRequest'

function useGeoFetch(
  startDate,
  endDate,
  entity,
  location,
  filterData,
  methodType
) {
  const payload = (location === 'activecbsa' || location === 'activecounty')
  ? {}
  : { startDate, endDate, ...filterData }

const { data, error } = useRequest({
  baseURL: process.env.REACT_APP_BACKEND_BASE_URL,
  url: `/${entity}/${location}`,
  method: methodType !== undefined ? methodType : 'GET',
  headers: {
    'Content-Type': 'application/json',
    requester: JSON.stringify(window.localStorage.getItem('requester'))
  },
  params: (methodType === 'GET' || methodType===undefined) ? payload : undefined,
  data: methodType === 'POST' ? payload : undefined,
  withCredentials: true,
})

  return { data, error }
}

export default useGeoFetch